import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'redux';
import FailedMessage from '../../credit_application/forms/PreQualAccessForm/FailedMessage';
import { APPLICATION_STATUS_MESSAGES } from '../constants/applicationStatusMessages';
import PendHandler from '../forms/PreQualAccessForm/PendHandler';
import { selectors } from '../reducer';
function PreQualificationAcceptFailedPage({ lenderReferenceId, lenderName, pendingDecisionDetails, personalInfo, prequalification, }) {
    const isAFFStepUpPend = () => {
        return (pendingDecisionDetails &&
            pendingDecisionDetails.url &&
            pendingDecisionDetails.url !== '#');
    };
    return (_jsx(_Fragment, { children: lenderName === 'AFF' ? (isAFFStepUpPend() ? (_jsx(PendHandler, { iframeUrl: pendingDecisionDetails.url, personalInfo: personalInfo, prequalification: prequalification })) : (_jsx(FailedMessage, { lenderReferenceId: lenderReferenceId }))) : (_jsx("div", { className: "declined-container", children: _jsxs("div", { className: "content", children: [_jsx("h1", { className: "first-title", children: "Credit Application" }), _jsx("p", { className: "first-subtitle", children: APPLICATION_STATUS_MESSAGES.PENDING.subtitle }), _jsx("p", { children: APPLICATION_STATUS_MESSAGES.PENDING.message }), lenderReferenceId && _jsxs("p", { children: [" Application ID: ", lenderReferenceId] })] }) })) }));
}
const mapDispatchToProps = {};
const mapStateToProps = (state) => {
    return {
        lenderReferenceId: selectors.lenderReferenceId(state),
        lenderName: selectors.lenderName(state),
        pendingDecisionDetails: selectors.pendingDecisionDetails(state),
        personalInfo: selectors.personalInfo(state),
        prequalification: selectors.prequalification(state),
    };
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(PreQualificationAcceptFailedPage);
